/* eslint-disable import/no-anonymous-default-export */
import * as actions from './actions';

export type State = {
  loading: boolean;
  data: Array<Record<string, any>>;
  error: object;
};

export default (
  state: State = {
    loading: false,
    data: [],
    error: {},
  },
  action: any = {},
): State => {
  switch (action.type) {
    case actions.FETCH_INCOME_EVENTS:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_INCOME_EVENTS_SUCCESS:
      const incomeEventsContent =
        action.payload &&
        action.payload.map((ie: any) => {
          return {
            value: ie.elements.sourceValue.value,
            name: ie.elements.sourceDisplayName.value,
          };
        });

      return {
        ...state,
        data: incomeEventsContent,
      };
    case actions.FETCH_INCOME_EVENTS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
